import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import useLocalStorage from 'src/shared/hooks/useLocalStorage';
import { Grid, TextField, CardHeader, Stack, CardContent, TableContainer, TableRow, TableHead, TableCell, Table, TableBody } from '@mui/material';
import call from 'src/core/services/http';
import { toast } from 'react-toastify';
import Page from "src/shared/components/Page";
import AuthService from 'src/core/access-control/AuthService';
import { useDispatch } from "react-redux";
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { LoadingButton } from '@mui/lab';
import Scrollbar from "src/shared/components/Scrollbar";
import { StyledTableCell, StyledTableRow } from "../../../shared/sections/@dashboard/tableStyle/tableBody";
import { useNavigate } from "react-router-dom";
import { CustomCell, CustomRow } from 'src/shared/TableComponents/TableStyles';
import AddIcon from '@mui/icons-material/Add';
import { getOperators } from "../../../shared/reducers/users/SharedUsersAction";


const TABLE_HEAD = [
  { id: 'mobileNumber', label: 'Mobile Number', alignLeft: true },

]


const IndividualFormSchema = Yup.object().shape({
  mobile_number: Yup.string().required("Required"),

});


const Notifications = () => {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [data, setData] = useState({
    checker_approval_required: false,
    signatory_approval_required: false,
  });
  const [loading, setLoading] = useState(true);
  const merchantId = AuthService.getUserId();
  const [shop] = useLocalStorage('shop-details');


  const defaultValues = {
    "mobile_number": "mobile_number",
    "savings_account_id": "shop.id",

  };


  const methods = useForm({
    resolver: yupResolver(IndividualFormSchema),
    defaultValues,
    mode: 'onChange'
  });

  const {
    handleSubmit, getValues, setValue, reset,
    formState: { isSubmitting },
  } = methods;


  const [state, setState] = useState(defaultValues)
  const [notification_number, setNotification_number] = useState([]);
  const [mobile_number, setMobileNumber] = useState('')


  const onSubmit = async () => {
    const data = {
      ...state,
      savings_account_id: shop.id,
      merchant_id: AuthService.getUserId(),
      mobile_number,
    };

    const res = await call("post", `/merchants/account-notifications/`, data);

    if (res.data.status) {
      toast.success(res.data.message);
      get_notification();
    } else {
      toast.error(res.data.message);
    }

    setState(defaultValues);
  };

  // Retreive Notification
  const get_notification = async () => {

    const data = {
      ...state,
      "savings_account_id": shop.id,
      "merchant_id": AuthService.getUserId(),
    }
    const res = await call("get", `/merchants/account-notifications/?merchant_id=${AuthService.getUserId()}&savings_account_id=${shop.id}`, data).catch(console.log);

    if (res.data.status) {
      setNotification_number(res.data.data);

    }
    else {
      toast.error(res.data.message)
    }

  };

  useEffect(() => {
    get_notification();
  }, []);

  const getSettings = async () => {
    try {
      const response = await call('get', `/merchants/${merchantId}/savings-accounts/${shop.id}/account-settings/`);
      if (response.data.status) {
        setData(response.data.account_settings);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSettings();
  }, []);


  const getUsers = () => {
    let payload = {
      merchantId: AuthService.getUserId(),
      savingsId: shop.id
    }

    dispatch(getOperators(payload))
  }


  useEffect(() => {
    getUsers()
  }, [dispatch])


  return (
    <Page title='Shop Settings'>
    
    <Grid item xs={12} md={8} lg={10} spacing={2}>
        <Grid item xs={12} md={4} lg={4}>
          <Card>
            <CardHeader
              sx={{ mb: 1, paddingTop: 2 }}
              title={<Typography color="text.info">Set a Notification Number</Typography>} />

            <CardContent>
              <TextField fullwidth
                onChange={(event) => { setMobileNumber(event.target.value) }}
                name="mobile_number"
                value={mobile_number}
                size="medium"
                label="Notification Number"
              />

              <Stack spacing={3} sx={{ my: 1, mr: 2, float: 'right' }}>
                <LoadingButton type="submit" variant="contained" size="small" loading={loading} onClick={onSubmit}>
                  <AddIcon />
                  Submit
                </LoadingButton>
              </Stack>
            </CardContent>

            <CardHeader
              sx={{ mb: 1, paddingTop: 2 }}
              title={<Typography color="text.info">Active Notification Number</Typography>} />
            <CardContent>
              <>
                <Scrollbar>
                  <TableContainer sx={{ maxWidth: 600, position: 'relative' }}>
                    <Table size={'small'}>
                      <TableHead>
                        <StyledTableRow>
                          {TABLE_HEAD.map((headCell) => (
                            <StyledTableCell key={headCell.id} align={headCell.alignRight ? 'right' : 'left'}>{headCell.label}</StyledTableCell>
                          ))}
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>
                        {notification_number && notification_number.length > 0 ? (
                          notification_number.map(({ mobile_number }, index) => (
                            <CustomRow hover role="checkbox" tabIndex={-1} key={index}>
                              <CustomCell>
                                {mobile_number}
                              </CustomCell>
                            </CustomRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell>
                              Add a Notification Number.
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Scrollbar>
              </>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Page>
  )
}

export default Notifications;
